import {
	LinearProgressProps,
	Box,
	LinearProgress,
	Typography,
} from '@mui/material'

function ProgressBar(
	props: LinearProgressProps & { value: number; label?: string }
) {
	return (
		<Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
			<Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
				<Box sx={{ width: '100%', mr: 1 }}>
					<LinearProgress
						variant="determinate"
						{...props}
						sx={{ height: '15px', borderRadius: '10px' }}
					/>
				</Box>
				<Box sx={{ minWidth: 35 }}>
					<Typography
						variant="body2"
						sx={{ color: '#fff', fontSize: '16px' }}
					>{`${Math.round(props.value)}%`}</Typography>
				</Box>
			</Box>
			{props.label && (
				<Box>
					<Typography
						variant="body2"
						sx={{ color: '#fff', fontSize: '16px' }}
					>
						{props.label}
					</Typography>
				</Box>
			)}
		</Box>
	)
}

export default ProgressBar
